<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="600px" persistent>
    <v-card>
      <v-card-title class="success white--text">
        <v-icon left>mdi-cash-plus</v-icon>
        {{ editMode ? 'แก้ไข' : 'เพิ่ม' }}การเลื่อนเงินเดือน
      </v-card-title>
      
      <v-card-text class="pt-4">
        <v-form ref="salaryForm" v-model="formValid">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="localData.effective_date"
                label="วันที่มีผล"
                type="date"
                outlined
                :rules="[v => !!v || 'กรุณาระบุวันที่มีผล']"
                :max="maxDate"
              />
            </v-col>
            
            <v-col cols="12" md="6">
              <v-text-field
                v-model="localData.amount"
                label="ค่าตอบแทนใหม่ (บาท)"
                type="number"
                min="0"
                outlined
                prepend-inner-icon="mdi-currency-usd"
                :rules="[
                  v => !!v || 'กรุณาระบุจำนวนเงิน', 
                  v => v > 0 || 'จำนวนเงินต้องมากกว่า 0'
                ]"
              />
            </v-col>
            
            <v-col cols="12">
              <v-text-field
                v-model="localData.order_number"
                label="เลขที่คำสั่ง"
                outlined
                :rules="[v => !!v || 'กรุณาระบุเลขที่คำสั่ง']"
              />
            </v-col>
            
            <v-col cols="12">
              <v-textarea
                v-model="localData.note"
                label="หมายเหตุ (ไม่บังคับ)"
                outlined
                rows="3"
                counter="500"
                :rules="[v => !v || v.length <= 500 || 'หมายเหตุต้องไม่เกิน 500 ตัวอักษร']"
              />
            </v-col>
            
            <v-col cols="12">
              <v-file-input
                v-model="localData.file"
                label="ไฟล์หลักฐานการเลื่อนเงินเดือน (ไม่บังคับ)"
                accept=".pdf,.jpg,.jpeg,.png"
                outlined
                show-size
                prepend-icon="mdi-paperclip"
                :rules="fileRules"
              >
                <template v-slot:selection="{ text }">
                  <v-chip small label color="success">
                    <v-icon left small>mdi-file</v-icon>
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
          
          <!-- แสดงจำนวนเงินที่จัดรูปแบบ -->
          <v-alert
            v-if="formattedAmount"
            type="success"
            outlined
            dense
            class="mt-3"
          >
            <div class="font-weight-medium">จำนวนเงิน: {{ formattedAmount }}</div>
          </v-alert>
        </v-form>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('close')">ยกเลิก</v-btn>
        <v-btn 
          color="success" 
          :loading="saving"
          :disabled="!formValid"
          @click="handleSave"
        >
          บันทึก
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SalaryDialog',
  
  props: {
    value: Boolean,
    editMode: Boolean,
    data: Object,
    saving: Boolean
  },
  
  data() {
    return {
      localData: {},
      formValid: false,
      
      fileRules: [
        v => !v || v.size < 5000000 || 'ไฟล์ต้องมีขนาดไม่เกิน 5MB'
      ]
    }
  },
  
  computed: {
    maxDate() {
      return new Date().toISOString().split('T')[0]
    },
    
    formattedAmount() {
      if (!this.localData.amount || this.localData.amount <= 0) return null
      
      return new Intl.NumberFormat('th-TH', {
        style: 'currency',
        currency: 'THB',
        minimumFractionDigits: 0
      }).format(this.localData.amount)
    }
  },
  
  watch: {
    data: {
      handler(newData) {
        this.localData = { ...newData }
      },
      immediate: true,
      deep: true
    },
    
    value(newVal) {
      if (newVal) {
        this.localData = { ...this.data }
        this.$nextTick(() => {
          if (this.$refs.salaryForm) {
            this.$refs.salaryForm.resetValidation()
          }
        })
      }
    }
  },
  
  methods: {
    handleSave() {
      if (this.$refs.salaryForm.validate()) {
        this.$emit('save', this.localData)
      }
    }
  }
}
</script>